import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import { useAuth } from '../../contexts/AuthContext';
import { PresenceProvider } from '../../contexts/PresenceContext';
import api from '../../lib/api';

const Layout = () => {
  const { user } = useAuth();

  // Global presence heartbeat - sends ping every 45s so all logged-in users appear online
  useEffect(() => {
    if (!user) return;
    const sendHeartbeat = () => {
      api.post('/chat/heartbeat').catch(() => {});
    };
    sendHeartbeat();
    const interval = setInterval(sendHeartbeat, 45000);
    return () => clearInterval(interval);
  }, [user]);

  return (
    <PresenceProvider user={user}>
      <div className="min-h-screen grid-bg relative ept-bg-ambient">
        <Header />
        <main className="pt-16 min-h-screen relative">
          <div className="p-4 md:p-6 lg:p-8 max-w-7xl mx-auto w-full">
            <Outlet />
          </div>
        </main>
      </div>
    </PresenceProvider>
  );
};

export default Layout;
